import React from 'react';
import { Button2, FlexGrid2, InformationIcon, Notification2, Styler, TypographyBody } from '@honeycomb/ui-core';
import { useGlobalContext, TripType } from '@honeycomb/data';
import { SearchAlternativeDatesButton } from './SearchAlternativeDatesButton';
import { LookForHotelOnlyButton } from './LookForHotelOnlyButton';
export var FilterResultsEnum;
(function (FilterResultsEnum) {
    FilterResultsEnum[FilterResultsEnum["FilterResultAvailable"] = 1] = "FilterResultAvailable";
    FilterResultsEnum[FilterResultsEnum["NoFilterResultAvailable"] = 2] = "NoFilterResultAvailable";
})(FilterResultsEnum || (FilterResultsEnum = {}));
export function HotelSearchNoResult({ state, actions }) {
    const { setHotelFilters, showFullSearch } = actions;
    const { filterResultReason, hotelSearch } = state;
    const isHoliday = hotelSearch.tripType === TripType.Holiday;
    const { resourceStrings: { NORESULTS_MATCHING_FILTERS_HOTELS_SUB, NORESULTS_MATCHING_FILTERS_MAIN, NOTAVL, NOHOTELDESC, RESETFILTERSBUTTON_CAPTION, }, } = useGlobalContext();
    const HEADING = filterResultReason === FilterResultsEnum.FilterResultAvailable ? NORESULTS_MATCHING_FILTERS_MAIN : NOTAVL;
    const MESSAGE = filterResultReason === FilterResultsEnum.FilterResultAvailable
        ? NORESULTS_MATCHING_FILTERS_HOTELS_SUB
        : NOHOTELDESC;
    return (React.createElement(React.Fragment, null,
        React.createElement(Styler, { mb: 5 },
            React.createElement(Notification2, { color: "info", icon: React.createElement(InformationIcon, null) },
                React.createElement(TypographyBody, { weight: "bold", "data-id": "no-matches-heading" }, HEADING),
                React.createElement("p", { "data-id": "no-matches-message" }, MESSAGE))),
        React.createElement(FlexGrid2, { container: true, mt: 5, spacing: 4 },
            React.createElement(FlexGrid2, { xs: 12, m: "auto" },
                React.createElement(SearchAlternativeDatesButton, { showFullSearch: showFullSearch, fullWidth: true })),
            React.createElement(FlexGrid2, { xs: 12, m: "auto" },
                !isHoliday && filterResultReason === FilterResultsEnum.FilterResultAvailable && (React.createElement(Button2, { size: "l", color: "primary", variant: "outlined", fullWidth: true, "data-id": "reset-filters", onClick: () => setHotelFilters([]) }, RESETFILTERSBUTTON_CAPTION)),
                isHoliday && React.createElement(LookForHotelOnlyButton, { fullWidth: true })))));
}
